<template>
  <v-card style="width: 100%;">
    <v-card-title>{{ $t('simulacion.modulo.planta_electrolisis.titulo') }}</v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container class="pa-2" fluid>
        <!-- BOP -->
        <v-row>
        <v-col cols="3" sm="3">
          <div class="text-h6">BOP</div>
        </v-col>
      </v-row>
        <!-- Datos operativos -->
        <v-row>
          <v-col cols="3" sm="3">
            <v-typography variant="h1">
              {{ $t('simulacion.modulo.planta_electrolisis.datos_operativos') }}
            </v-typography>
          </v-col>
        </v-row>

        <!-- Consumo electricidad BOP -->
        <v-row>
          <v-col cols="3" sm="5" xl="4">
            <v-text-field
              density="compact"
              rounded="sm"
              variant="outlined"
              class="wrap-label"
              :label="formatLabel('cauxmn')"
              :model-value="formatNumber(cauxmn)"
  @update:modelValue="val => cauxmn = val"
              
              :hint="getHint('cauxmn')"
              :rules="[rules.Negativo]"
            />
          </v-col>
          <v-col cols="3" sm="5" xl="4" >
            <v-text-field
              density="compact"
              rounded="sm"
              variant="outlined"
              class="wrap-label"
              :label="formatLabel('cauxmx')"
              :model-value="formatNumber(cauxmx)"
  @update:modelValue="val => cauxmx = val"
              
              :hint="getHint('cauxmx')"
              :rules="[rules.Negativo]"
            />
          </v-col>
        </v-row>




        
        <!-- Datos económicos -->
        <v-row class="mt-4">
          <v-col cols="12">
            <v-typography variant="h1">
              {{ $t('simulacion.modulo.planta_electrolisis.datos_economicos') }}
            </v-typography>
          </v-col>
        </v-row>

        <v-row>
        <v-col cols="12" sm="6">
          <!-- Legacy  :label="usarCurvasBOP ? $t('simulacion.modulo.curvas_CAPEXOPEX.capex_opex_curvas') : $t('simulacion.modulo.curvas_CAPEXOPEX.capex_opex_especifico')" -->
          <v-switch
            v-model="usarCurvasBOP"
            :label=" $t('simulacion.modulo.curvas_CAPEXOPEX.capex_opex_curvas')"
            inset
            hide-details
            color="blue"         
            track-color="grey"
          />
        </v-col>
      </v-row>

      <v-row v-if="!usarCurvasBOP">
        <v-col cols="12" sm="6" md="4">
          <ComponenteEditorCAPEXOPEX
            :titulo="$t('simulacion.modulo.planta_electrolisis.capex')"
            v-model:valorVariable="datos.capexv"
            v-model:valorFijo="datos.capexf"
            unidad-variable="kEUR/MW"
            unidad-fijo="kEUR"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <ComponenteEditorCAPEXOPEX
            :titulo="$t('simulacion.modulo.planta_electrolisis.opex')"
            v-model:valorVariable="datos.opexv"
            v-model:valorFijo="datos.opexf"
            unidad-variable="kEUR/MW año"
            unidad-fijo="kEUR año"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-switch
            v-model="usarCurvasConexion"
            :label="usarCurvasConexion ? $t('simulacion.modulo.ejecucion.switch.conexion') : $t('simulacion.modulo.ejecucion.switch.conexion')"
            inset
            hide-details
            color="blue"         
            track-color="grey"
          />
        </v-col>
      </v-row>

      <v-row v-if="usarCurvasConexion">
        <v-col cols="12" sm="6" md="4">
          <ComponenteEditorCAPEXOPEX
            :titulo="$t('simulacion.modulo.planta_electrolisis.capexcel')"
            v-model:valorVariable="datos.capexvcel"
            v-model:valorFijo="datos.capexfcel"
            unidad-variable="kEUR/MW"
            unidad-fijo="kEUR"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <ComponenteEditorCAPEXOPEX
            :titulo="$t('simulacion.modulo.planta_electrolisis.opexcel')"
            v-model:valorVariable="datos.opexvcel"
            v-model:valorFijo="datos.opexfcel"
            unidad-variable="kEUR/MW año"
            unidad-fijo="kEUR año"
          />
        </v-col>
      </v-row>
      <br><br><br>
      
       <!-- Otros -->
       <v-row v-if="usarDucto || usarConexion || usarTube">
        <v-col cols="3" sm="3">
          <div class="text-h6">{{ $t('simulacion.modulo.planta_electrolisis.otros') }}</div>
        </v-col>
      </v-row>
      <!-- Dimensión ducto -->
      <v-row v-if="usarDucto">
          <v-col cols="3" sm="3">
            <v-text-field
              density="compact"
              rounded="sm"
              variant="outlined"
              :label="formatLabel('dimducto')"
              v-model.number="datos.dimducto"
              type="number"
              :hint="getHint('dimducto')"
              :rules="[rules.Negativo]"
            />
          </v-col>

          <v-col cols="3" sm="3">
            <v-text-field
              density="compact"
              rounded="sm"
              variant="outlined"
              :label="$t('simulacion.modulo.planta_electrolisis.capexduc')"
              :model-value="formatNumber(capexDucto)"
              @update:modelValue="val => capexDucto = Number(val.replace(',', '.'))"
              :disabled="disableDucto"
              class="wrap-label"
            />
          </v-col>

          <v-col cols="3" sm="3">
            <v-text-field
              density="compact"
              rounded="sm"
              variant="outlined"
              :label="$t('simulacion.modulo.planta_electrolisis.opexduc')"
              :model-value="formatNumber(opexDucto)"
              @update:modelValue="val => opexDucto = Number(val.replace(',', '.'))"
              :disabled="disableDucto"
              class="wrap-label"
            />
          </v-col>
          <v-col cols="2" class="switch-top">

            <v-switch
              v-model="usarCurvasDucto"
              :label="usarCurvasDucto ? $t('simulacion.modulo.curvas_CAPEXOPEX.switch_curvas') : $t('simulacion.modulo.curvas_CAPEXOPEX.switch_especificos')"
              hide-details
              inset
              color="blue"
            />
          </v-col>
        </v-row>

        <!-- Conexión eléctrica 
        <v-row v-if="usarConexion">
          <v-col cols="4" sm="3">
            <v-text-field
              density="compact"
              rounded="sm"
              variant="outlined"
              :label="formatLabel('dimconexelec')"
              v-model.number="datos.dimconexelec"
              type="number"
              :hint="getHint('dimconexelec')"
              :rules="[rules.Negativo]"
              class="wrap-label"
            />
          </v-col>

          

          <v-col cols="3" sm="3">
            <v-text-field
              density="compact"
              rounded="sm"
              variant="outlined"
              :label="$t('simulacion.modulo.planta_electrolisis.capexele')"
              
              :model-value="formatNumber(capexConexion)"
  @update:modelValue="val => capexConexion = Number(val.replace(',', '.'))"
              :disabled="disableConexion"
              class="wrap-label"
            />
          </v-col>

          <v-col cols="3" sm="3">
            <v-text-field
              density="compact"
              rounded="sm"
              variant="outlined"
              :label="$t('simulacion.modulo.planta_electrolisis.opexele')"
              :model-value="formatNumber(opexConexion)"
  @update:modelValue="val => opexConexion = Number(val.replace(',', '.'))"
              :disabled="disableConexion"
              class="wrap-label"
            />
          </v-col>
          <v-col cols="2" class="switch-top">
            <v-switch
              v-model="usarCurvasConexion"
              :label="usarCurvasConexion ? $t('simulacion.modulo.curvas_CAPEXOPEX.switch_curvas') : $t('simulacion.modulo.curvas_CAPEXOPEX.switch_especificos')"
              hide-details
              inset
              color="blue"
            />
          </v-col>
        </v-row>-->

        <!-- Tube-tráiler -->
        <v-row v-if="usarTube">
          <v-col cols="3" sm="3">
            <v-text-field
              density="compact"
              rounded="sm"
              variant="outlined"
              :label="formatLabel('dimtube')"
              v-model.number="datos.dimtube"
              type="number"
              :hint="getHint('dimtube')"
              :rules="[rules.Negativo]"
            />
          </v-col>

          

          <v-col cols="3" sm="3">
            <v-text-field
              density="compact"
              rounded="sm"
              variant="outlined"
              :label="$t('simulacion.modulo.planta_electrolisis.capextra')"
              :model-value="formatNumber(capexTube)"
  @update:modelValue="val => capexTube = Number(val.replace(',', '.'))"
              :disabled="disableTube"
              class="wrap-label"
              
            />
          </v-col>

          <v-col cols="3" sm="3">
            <v-text-field
              density="compact"
              rounded="sm"
              variant="outlined"
              :label="$t('simulacion.modulo.planta_electrolisis.opextra')"
              :model-value="formatNumber(opexTube)"
  @update:modelValue="val => opexTube = Number(val.replace(',', '.'))"
              :disabled="disableTube"
              class="wrap-label"
            />
          </v-col>
          <v-col cols="2" class="switch-top">
            <v-switch
              v-model="usarCurvasTube"
              :label="usarCurvasTube ? $t('simulacion.modulo.curvas_CAPEXOPEX.switch_curvas') : $t('simulacion.modulo.curvas_CAPEXOPEX.switch_especificos')"
              hide-details
              inset
              color="blue"
            />
          </v-col>
        </v-row>


      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import ComponenteEditorCAPEXOPEX from '../components/ComponenteEditorCAPEXOPEX.vue';

export default {
  props: {
    planta_electrolisis: {
    type: Object,
    required: true
  },
    gen: Object,
    tablas: Array,
    usarCapexOpexGeneralPlanta: String,
    usarDucto: Boolean,
    usarConexion: Boolean,
    usarTube: Boolean
  },
  components: { ComponenteEditorCAPEXOPEX },
  data() {
    return {

      disableOn:false,
      datos: {
        ...this.planta_electrolisis,
         capexfcel: this.planta_electrolisis?.capexfcel ?? 0,
      capexvcel: this.planta_electrolisis?.capexvcel ?? 0,
      opexfcel:  this.planta_electrolisis?.opexfcel  ?? 0,
      opexvcel:  this.planta_electrolisis?.opexvcel  ?? 0,
        curvas: {
          capex: this.planta_electrolisis?.curvas?.capex,
          opex: this.planta_electrolisis?.curvas?.opex
        },
        curvas_conexion: {
        capex: this.planta_electrolisis?.curvas_conexion?.capex ?? 0,
        opex:  this.planta_electrolisis?.curvas_conexion?.opex  ?? 0,
      },
      },
      local_gen: { ...this.gen },
      usarCapexOpexGeneral: this.usarCapexOpexGeneralPlanta || 'especifico',
      usarCurvasDucto: true,
      //usarCurvasConexion: true,
      usarCurvasTube: true,
      rules: {
        Negativo: (v) => {
          if (v === null || v === undefined || v === '') return true;

          const num = Number(v.toString().replace(',', '.'));

          return isNaN(num) ? 'Valor inválido' : (num >= 0 ? true : 'El valor no puede ser negativo');
        },
        required: v => !!v || this.$t('mensajes.campo_requerido'),
        mas24: v => v>24 || "Debe ser menor de 24",
        },
    };
  },
  computed: {
    cauxmn: {
  get() { return this.datos.cauxmn * 100 },
  set(val) {
    const parsed = Number(val.toString().replace(',', '.'));
    this.datos.cauxmn = isNaN(parsed) ? 0 : parsed / 100;
  }
},
cauxmx: {
  get() { return this.datos.cauxmx * 100 },
  set(val) {
    const parsed = Number(val.toString().replace(',', '.'));
    this.datos.cauxmx = isNaN(parsed) ? 0 : parsed / 100;
  }
},
    dimducto: {
      get() { return this.datos.dimducto },
      set(val) {
        this.datos.dimducto = Number(val);
        this.datos.capexduc = this.calcularValor('Ducto', val, 'capex') || 0;
        this.datos.opexduc = this.calcularValor('Ducto', val, 'opex') || 0;
      }
    },
   /* dimconexelec: {
      get() { return this.datos.dimconexelec },
      set(val) {
        this.datos.dimconexelec = Number(val);
        this.datos.capexele = this.calcularValor('Conexión eléctrica', val, 'capex') || 0;
        this.datos.opexele = this.calcularValor('Conexión eléctrica', val, 'opex') || 0;
      }
    },*/
    dimtube: {
      get() { return this.datos.dimtube },
      set(val) {
        this.datos.dimtube = Number(val);
        this.datos.capextra = this.calcularValor('Tube-tráiler', val, 'capex') || 0;
        this.datos.opextra = this.calcularValor('Tube-tráiler', val, 'opex') || 0;
      }
    },
    capexDucto: {
  get() {
    return this.datos.capexduc;
  },
  set(val) {
    this.datos.capexduc = Number(val);
  }
},
  opexDucto: {
    get() {
      return this.datos.opexduc;
    },
    set(val) {
      this.datos.opexduc = Number(val);
    }
  },
  /*capexConexion: {
    get() {
      return this.datos.capexele;
    },
    set(val) {
      this.datos.capexele = Number(val);
    }
  },
  opexConexion: {
    get() {
      return this.datos.opexele;
    },
    set(val) {
      this.datos.opexele = Number(val);
    }
  },*/
  capexTube: {
    get() {
      return this.datos.capextra;
    },
    set(val) {
      this.datos.capextra = Number(val);
    }
  },
  opexTube: {
    get() {
      return this.datos.opextra;
    },
    set(val) {
      this.datos.opextra = Number(val);
    }
  },

    usarCurvasBOP: {
      get() {
        return this.datos.curvas?.capex === 1 && this.datos.curvas?.opex === 1;
      },
      set(val) {
        this.datos.curvas.capex = val ? 1 : 0;
        this.datos.curvas.opex = val ? 1 : 0;
      }
    },
    usarCurvasConexion: {
    get() {
      return this.datos.curvas_conexion?.capex === 1 && this.datos.curvas_conexion?.opex === 1;
    },
    set(v) {
      this.datos.curvas_conexion.capex = v ? 1 : 0;
      this.datos.curvas_conexion.opex  = v ? 1 : 0;
       // Si apagamos el switch, reseteamos los valores
    if (!v) {
      this.datos.capexfcel = 0
      this.datos.capexvcel = 0
      this.datos.opexfcel  = 0
      this.datos.opexvcel  = 0
    }
    }
    },
    disableDucto() {
      return this.usarCurvasDucto;
    },
    /*disableConexion() {
      return this.usarCurvasConexion;
    },*/
    disableTube() {
      return this.usarCurvasTube;
    },
    

  },
  
  watch: {
  datos: {
    handler(newVal) {
      this.$emit('update:planta_electrolisis', newVal);
    },
    deep: true
  },
  tablas: {
    handler(newTablas) {
      this.actualizarCurvasDesdeTablas(newTablas);
    },
    deep: true
  },


  local_gen: {
    handler(val) {
      this.$emit('update:gen', val);
    },
    immediate: true,
    deep: true
  },
  usarCapexOpexGeneral: {
    handler() {
      this.emitirOpcionGeneral();
    }
  },
 'datos.dimducto'(val) {
    if (this.usarCurvasDucto) {
      this.datos.capexduc = this.calcularValor('Ducto', val, 'capex') || 0;
      this.datos.opexduc = this.calcularValor('Ducto', val, 'opex') || 0;
    }
  },
  /*'datos.dimconexelec'(val) {
    if (this.usarCurvasConexion) {
      this.datos.capexele = this.calcularValor('Conexión eléctrica', val, 'capex') || 0;
      this.datos.opexele = this.calcularValor('Conexión eléctrica', val, 'opex') || 0;
    }*/
  'datos.dimtube'(val) {
    if (this.usarCurvasTube) {
      this.datos.capextra = this.calcularValor('Tube-tráiler', val, 'capex') || 0;
      this.datos.opextra = this.calcularValor('Tube-tráiler', val, 'opex') || 0;
    }
  },

  usarCurvasDucto(val) {
    if (val) {
      const valD = this.datos.dimducto;
      this.datos.capexduc = this.calcularValor('Ducto', valD, 'capex') || 0;
      this.datos.opexduc = this.calcularValor('Ducto', valD, 'opex') || 0;
    }
  },
 /* usarCurvasConexion(val) {
    if (val) {
      const d = this.datos.dimconexelec;
      this.datos.capexele = this.calcularValor('Conexión eléctrica', d, 'capex') || 0;
      this.datos.opexele = this.calcularValor('Conexión eléctrica', d, 'opex') || 0;
    }
  },*/
  usarCurvasTube(val) {
    if (val) {
      const d = this.datos.dimtube;
      this.datos.capextra = this.calcularValor('Tube-tráiler', d, 'capex') || 0;
      this.datos.opextra = this.calcularValor('Tube-tráiler', d, 'opex') || 0;
    }
  },
   usarDucto(val) {
    this.datos.usarCurvasDucto = false;
    if (!val) {
      this.datos.dimducto = 0;
      this.datos.capexduc = 0;
      this.datos.opexduc = 0;
    }
  },
 /*usarConexion(val) {
    this.datos.usarCurvasConexion = false;
    if (!val) {
      this.datos.dimconexelec = 0;
      this.datos.capexele = 0;
      this.datos.opexele = 0;
    }
  },*/
  usarTube(val) {
    this.datos.usarCurvasTube = false;
    if (!val) {
      this.datos.dimtube = 0;
      this.datos.capextra = 0;
      this.datos.opextra = 0;
    }
  }
},
  methods: {
      actualizarDatos(){

        this.datos={
        ...this.planta_electrolisis,
         capexfcel: this.planta_electrolisis?.capexfcel ?? 0,
      capexvcel: this.planta_electrolisis?.capexvcel ?? 0,
      opexfcel:  this.planta_electrolisis?.opexfcel  ?? 0,
      opexvcel:  this.planta_electrolisis?.opexvcel  ?? 0,
        curvas: {
          capex: this.planta_electrolisis?.curvas?.capex,
          opex: this.planta_electrolisis?.curvas?.opex
        },
        curvas_conexion: {
        capex: this.planta_electrolisis?.curvas_conexion?.capex ?? 0,
        opex:  this.planta_electrolisis?.curvas_conexion?.opex  ?? 0,
      },
      }

      },
    formatNumber(value) {
      if (value === null || value === undefined || value === '') return '';
    if (typeof value !== 'number') value = Number(value);

    // Redondeamos a, por ejemplo, 4 decimales (ajusta según necesidad)
    const rounded = Math.round((value + Number.EPSILON) * 1e4) / 1e4;

    // Convertimos a string y cambiamos punto por coma
    return rounded.toString().replace('.', ',');
  },

    updateNumber(obj, field, val) {
      const parsed = Number(val.replace(',', '.'));
      obj[field] = isNaN(parsed) ? 0 : parsed;
    },
    formatLabel(key) {
      return this.$t('simulacion.modulo.planta_electrolisis.' + key);
    },
    getHint(key) {
      return key === 'capex' ? 'In currency' : '';
    },
   calcularValor(nombreTabla, dimension, campo) {
    const tabla = this.tablas.find(t => t.nombre === nombreTabla);
    if (!tabla || !Array.isArray(tabla.filas)) return 0;

    const filas = tabla.filas.map(f => ({
      unidad: Number(f.unidad),
      capex: Number(f.capex),
      opex: Number(f.opex)
    }));

    // Ordenar
    filas.sort((a, b) => a.unidad - b.unidad);

    // Si coincide
    const exacta = filas.find(f => f.unidad === Number(dimension));
    if (exacta) return exacta[campo];

    // Si está entre dos valores: interpolación
    for (let i = 0; i < filas.length - 1; i++) {
      const x1 = filas[i].unidad;
      const x2 = filas[i + 1].unidad;

      if (dimension > x1 && dimension < x2) {
        const y1 = filas[i][campo];
        const y2 = filas[i + 1][campo];
        const pendiente = (y2 - y1) / (x2 - x1);
        return Number((pendiente * (dimension - x1) + y1).toFixed(2));
      }
    }

    if (dimension > filas[filas.length - 1].unidad) {
      const x1 = filas[filas.length - 2].unidad;
      const x2 = filas[filas.length - 1].unidad;
      const y1 = filas[filas.length - 2][campo];
      const y2 = filas[filas.length - 1][campo];
      const pendiente = (y2 - y1) / (x2 - x1);
      return Number((pendiente * (dimension - x2) + y2).toFixed(2));
    }

    // Si es menor que el primer valor, usar primer tramo (esto estaba bien)
    const xBase = filas[0].unidad;
    const yBase = filas[0][campo];
    const ratio = yBase / xBase;

    return Number((ratio * dimension).toFixed(2));
  },




    emitirOpcionGeneral() {
      this.$emit('update:usarCapexOpexGeneralPlanta', this.usarCapexOpexGeneral);
    },

    actualizarCurvasDesdeTablas(nuevasTablas) {
      if (!Array.isArray(nuevasTablas)) return;

      if (this.usarCurvasDucto && this.datos.dimducto) {
        this.datos.capexduc = this.calcularValor('Ducto', this.datos.dimducto, 'capex') || 0;
        this.datos.opexduc = this.calcularValor('Ducto', this.datos.dimducto, 'opex') || 0;
      }
     /* if (this.usarCurvasConexion && this.datos.dimconexelec) {
        this.datos.capexele = this.calcularValor('Conexión eléctrica', this.datos.dimconexelec, 'capex') || 0;
        this.datos.opexele = this.calcularValor('Conexión eléctrica', this.datos.dimconexelec, 'opex') || 0;
      }*/
      if (this.usarCurvasTube && this.datos.dimtube) {
        this.datos.capextra = this.calcularValor('Tube-tráiler', this.datos.dimtube, 'capex') || 0;
        this.datos.opextra = this.calcularValor('Tube-tráiler', this.datos.dimtube, 'opex') || 0;
      }
    }
  },
  mounted() {
  console.log('[Electrólisis] Tablas recibidas:', this.tablas);
}

};
</script>
<style scoped>
.switch-top {
  display: flex;
  align-items: flex-start;
  padding-top: 4px; 
}
</style>
